/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BackAndroidIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Back Android',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.5 16.08h-28l9.94-9.94a.967.967 0 0 0 0-1.4l-.7-.72a1.027 1.027 0 0 0-1.42 0L2.48 16.88a1.027 1.027 0 0 0 0 1.42l12.78 13.68a1.027 1.027 0 0 0 1.42 0l.7-.7a1.027 1.027 0 0 0 0-1.42L7.52 19H35.5a.5.5 0 0 0 .5-.5v-1.92a.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
